<template>
  <div class="layout layout-column">
    <div v-bind:style="{'z-index': '4'}" class="layout-align-start-center py-2 px-2">
      <lx-btn :disabled="isDisabled"
              icon="add_circle"
              :color="compColor.primeColor"
              :iconColor="'white'"
              :tooltip="$t('FORMS_DIVERSE.ADD_NEW_FURTHER_CLASSIFICATION')"
              :label="$t('FORMS_DIVERSE.ADD_NEW_FURTHER_CLASSIFICATION')"
              iconSize="21"
              :width="'auto'"
              :height="35"
              classes="text-none"
              @click="addItem(path)"
      ></lx-btn>
    </div>

    <v-divider v-bind:style="{'border-color':compColor.lightDivider}" v-if="model && model.length > 0"></v-divider>

    <div :key="index" v-for="(item, index) in model"
         class="layout-row pa-0 ma-2"
         :class="{'elevation-5': compColor.isInDarkMode, 'grey lighten-3': !compColor.isInDarkMode}"
         style="border-radius:4px;"
         :style="{'border': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">

      <div class="layout-row layout-wrap flex px-3">

        <!-- Name der Klassifikation -->

        <div class="flex-gt-sm-50 flex-100 px-2 py-3">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.name'"
                               :ref="path + '.' + index + '.name'"
                               rules="required"
                               v-slot="{ errors }">
            <v-select
              :label="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_NAME') + ' *'"
              :color="compColor.primeColor"
              :dark="compColor.isInDarkMode"
              v-model="item.name"
              :disabled="isDisabled"
              :hide-details="!errors || errors.length <= 0"
              :dense="denseFields"
              outlined
              @change="deleteStadiumAfterChangingName(index)"
              :error-messages="errors[0]"
              :menu-props="{ bottom: true, offsetY: true }"
              class="ma-0"
              :items="classifications"
              item-text="name">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ item.name }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template #no-data>
                <div class="layout-row pt-1 pb-1 pl-3 pr-3">
                  <div class="flex layout-row mr-3">
                    {{ diagCode ? $t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_NO_DATA', {code: diagCode}) : $t('NO_ROWS') }}
                  </div>
                </div>
              </template>
            </v-select>
          </validation-provider>
        </div>

        <!-- Stadium der Klassifikation -->

        <div class="flex-gt-sm-50 flex-100 px-2 py-3">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.stadium'"
                               :ref="path + '.' + index + '.stadium'"
                               rules="required"
                               v-slot="{ errors }">
            <v-select
              :label="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_STADIUM') + ' *'"
              :color="compColor.primeColor"
              :dark="compColor.isInDarkMode"
              v-model="item.stadium"
              :disabled="isDisabled||!item.name"
              :hide-details="!errors || errors.length <= 0"
              :dense="denseFields"
              outlined
              :error-messages="errors[0]"
              :menu-props="{ bottom: true, offsetY: true }"
              class="ma-0"
              :items="getClassificationStadiums(item.name)"
              item-value="name"
              :item-text="formatStadium">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ formatStadium(item) }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </validation-provider>
        </div>

        <!-- Datum der Klassifikation  -->

        <div class="flex-gt-sm-50 flex-100 px-2 py-3">
          <validation-provider tag="div"
                               :name="path + '.' + index + '.datum'"
                               :ref="path + '.' + index + '.datum'"
                               :rules="{german_date:true,date_not_in_future:true,date_must_be_lesser_than_death:[deathDate,item.datum_genauigkeit]}"
                               v-slot="{ errors }">
            <lx-datepicker
              :color="compColor.textInput"
              :name="path + '.' + index + '.datum'"
              :label="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_DATE')"
              :dense="denseFields"
              @input="setDateAccuracyAfterDate(index)"
              :disabled="isDisabled"
              :hide-details="!errors || errors.length <= 0"
              :error="errors[0]"
              v-model="item.datum"
            ></lx-datepicker>
          </validation-provider>
        </div>

        <!-- Datumsgenauigkeit der Klassifikation  -->

        <div class="flex-gt-sm-50 flex-100 px-2 py-3 layout-row">
          <validation-provider tag="div"
                               class="flex"
                               :name="path + '.' + index + '.datum_genauigkeit'"
                               :ref="path + '.' + index + '.datum_genauigkeit'"
                               rules=""
                               v-slot="{ errors }">
            <v-select
              :color="compColor.primeColor"
              :label="$t('FORMS_DIVERSE.FURTHER_CLASSIFICATION_DATE_ACCURACY')"
              v-model="item.datum_genauigkeit"
              :items="DateAccuracyTypes"
              :disabled="isDisabled || !item.datum"
              outlined
              @change="validateDateAfterChangeOfAccuracy(index)"
              :hide-details="!errors || errors.length <= 0"
              :dense="denseFields"
              :error-messages="errors[0]"
              :menu-props="{ bottom: true, offsetY: true }"
              :dark="compColor.isInDarkMode">
              <template v-slot:item="{ item, on, attrs }">
                <v-list-item v-on="on"
                             :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                  <v-list-item-content class="py-0">
                    <label style="cursor:pointer;"
                           :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                           class="lighten-4 text--darken-2">{{ item.text }}</label>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-select>
          </validation-provider>

          <v-tooltip bottom open-delay="1000">
            <template v-slot:activator="{ on }">
              <div v-on="on" class="blue--text text--lighten-1 layout-row layout-align-start-start pt-2 ml-3"
                   :class="{'mt-1': !denseFields}"
                   style="cursor: pointer;">
                <v-icon :color="compColor.prime" medium>info</v-icon>
              </div>
            </template>
            <p style="max-width: 400px;" class="my-1">{{ $t('FORMS_DIVERSE.TOOLTIP_DATE_ACCURACY') }}</p>
          </v-tooltip>
        </div>

      </div>

      <div class="layout-column layout-align-center-center px-3"
           :class="{'grey lighten-2': !compColor.isInDarkMode}"
           :style="{'border-left': compColor.isInDarkMode ? '1px solid #cccccc22 !important' : '1px solid #ccc !important;' }">
        <lx-btn @click="deleteClassification(path, index, path + '.' + index + '.name')"
                :color="compColor.primeColor"
                :iconColor="'white'"
                iconSize="21"
                :width="35"
                :height="35"
                :disabled="isDisabled"
                icon="delete_forever"></lx-btn>
      </div>
    </div>
  </div>
</template>

<script>
import metaData from '../shared/formsMetaData'

export default {
  name: "WeitereKlassifikation",
  mixins: [metaData],
  props: {
    value: {
      type: Array,
      default: () => ([])
    },
    path: {
      type: String
    },
    addItem: {
      type: Function
    },
    deleteItem: {
      type: Function
    },
    isDisabled: {
      type: Boolean
    },
    patientId: {
      type: String
    },
    validationRef: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      model: [],
      DateAccuracyTypes: null,
      classifications: []
    }
  },
  created () {
    this.DateAccuracyTypes = this.formsMetaData.DateAccuracyShort
  },
  methods: {
    /**
     * Delete selected stadium after changing name of classification
     *
     * @param index The index of selected classification
     */
    deleteStadiumAfterChangingName (index) {
      this.$delete(this.model[index], 'stadium')
    },

    /**
     * Delete selected element of death causes and trigger validator for saving
     */
    deleteClassification (path, index, field) {
      this.deleteItem(path, index)
      this.validationRef.fields[field].changed = true
    },

    /**
     * Validate date after changing date accuracy
     *
     * @param index The index of selected classification
     */
    validateDateAfterChangeOfAccuracy (index) {
      this.$nextTick(() => {
        if (this.$refs[this.path + '.' + index + '.datum'] && this.$refs[this.path + '.' + index + '.datum'][0]) {
          this.$refs[this.path + '.' + index + '.datum'][0].validate()
        }
      })
    },

    /**
     * Set date accuracy per default after date input
     *
     * @param index The index of selected classification
     */
    setDateAccuracyAfterDate (index) {
      // set datum if not exists after changing datum_genauigkeit in datepicker
      if (this.model[index] && this.model[index].datum && !this.model[index].datum_genauigkeit) {
        this.$set(this.model[index], 'datum_genauigkeit', 'E')
      } else if (!this.model[index].datum) {
        // delete date accuracy, if date was deleted
        this.$set(this.model[index], 'datum_genauigkeit', undefined)
      }
    },

    /**
     * Get classification stadiums for current classification name
     *
     * @param classificationName The name of current classification
     */
    getClassificationStadiums (classificationName) {
      const classification = this.classifications.find(current => {
        return current.name === classificationName
      })
      return classification ? classification.stadium : []
    },

    /**
     * Return formatted stadium entry
     *
     * @param stadium The current stadium
     */
    formatStadium (stadium) {
      let text = stadium.name

      if (stadium.description) {
        text += ' - ' + stadium.description
      }
      return text
    }
  },
  computed: {
    deathDate () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).deathDate : undefined
    },
    diagCode () {
      return this.patientId ? this.$store.getters.diagnosisBaseData(this.patientId).diagCode : undefined
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    },
    diagCode: {
      handler: function (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.$http.get('/classifications/search/' + newValue)
            .then(res => {
              this.classifications = res.data || []
            })
            .catch(this.NotifyError)
        }
      },
      immediate: true
    }
  }
}
</script>
